import { DOORDASH_DRIVE_DEFAULT_TIP } from '@olo-web/domain/orders/constants';

export const getTipsValues = (orderDetails?: IMerchantOrderTypeDetails, isThirdPartyDelivery?) => {
  let suggestedTipPercentages = [15, 20, 25];

  if (orderDetails?.suggestedTipPercentages?.length) {
    suggestedTipPercentages = [...orderDetails?.suggestedTipPercentages];
  }

  if (isThirdPartyDelivery) {
    let isSet = false;
    suggestedTipPercentages = suggestedTipPercentages.map((tip, idx) => {
      if (!isSet && (tip >= 20 || idx === 2)) {
        isSet = true;
        return DOORDASH_DRIVE_DEFAULT_TIP;
      }
      return tip;
    });
  }

  return suggestedTipPercentages;
};
